module.exports = __webpack_public_path__ + "static/cssday-2026-100-bae1148c23f55bc4dd031c24ca07fbb3.jpg";